(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  (() => {
    if (window.__ocHeaderIntegratedV2) return;
    window.__ocHeaderIntegratedV2 = true;

    const escapeHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const initLiveSearch = () => {
      const root = document.querySelector('[data-oc-header-live-search]');
      const form = root?.querySelector('#OCDesktopSearchForm');
      const input = root?.querySelector('#OCDesktopSearch');
      const results = root?.querySelector('[data-oc-header-live-results]');
      const status = root?.querySelector('[data-oc-header-live-status]');
      if (!root || !form || !input || !results) return;

      const cache = new Map();
      let timer = 0;
      let controller = null;
      let selectedIndex = -1;

      const getItems = () => Array.from(results.querySelectorAll('[data-oc-header-live-option]'));

      const close = () => {
        root.classList.remove('is-open');
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        selectedIndex = -1;
        getItems().forEach((item) => item.setAttribute('aria-selected', 'false'));
      };

      const open = () => {
        if (!results.innerHTML.trim()) return;
        results.hidden = false;
        root.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      };

      const selectItem = (index) => {
        const items = getItems();
        if (!items.length) return;
        items.forEach((item) => item.setAttribute('aria-selected', 'false'));
        selectedIndex = (index + items.length) % items.length;
        const active = items[selectedIndex];
        active.setAttribute('aria-selected', 'true');
        if (!active.id) active.id = 'oc-header-live-option-' + selectedIndex;
        input.setAttribute('aria-activedescendant', active.id);
        active.scrollIntoView({ block: 'nearest' });
      };

      const displayPrice = (product) => {
        const price = product?.price;
        if (price == null || price === '') return '';
        if (typeof price === 'string' && /[$€£¥]/.test(price)) return price;
        const numeric = Number(price);
        if (!Number.isFinite(numeric)) return String(price);
        try {
          return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: window.Shopify?.currency?.active || 'USD'
          }).format(numeric);
        } catch (_) {
          return '$' + numeric.toFixed(2);
        }
      };

      const render = (products, term) => {
        const list = products.map((product) => {
          const image = product?.featured_image?.url || product?.featured_image || product?.image || '';
          const title = escapeHtml(product?.title || '');
          const href = escapeHtml(product?.url || '#');
          const price = escapeHtml(displayPrice(product));
          return `<a class="oc-header-live-item" href="${href}" role="option" aria-selected="false" data-oc-header-live-option>
            <span class="oc-header-live-thumb">${image ? `<img src="${escapeHtml(image)}" alt="" width="56" height="56" loading="lazy">` : ''}</span>
            <span class="oc-header-live-copy">
              <span class="oc-header-live-title">${title}</span>
              ${price ? `<span class="oc-header-live-price">${price}</span>` : ''}
            </span>
          </a>`;
        }).join('');

        const searchHref =
          form.action +
          '?q=' +
          encodeURIComponent(term) +
          '&options%5Bprefix%5D=last';

        results.innerHTML =
          '<div class="oc-header-live-heading">PRODUCTS</div>' +
          '<div class="oc-header-live-list">' +
          (list || '<div class="oc-header-live-empty">NO PRODUCTS FOUND</div>') +
          '</div>' +
          `<a class="oc-header-live-all" href="${searchHref}" role="option" aria-selected="false" data-oc-header-live-option>SEARCH FOR “${escapeHtml(term)}”</a>`;

        if (status) status.textContent = products.length ? products.length + ' results' : 'No results';
        selectedIndex = -1;
        open();
      };

      const requestResults = async (term) => {
        const key = term.toLocaleLowerCase();
        if (cache.has(key)) {
          render(cache.get(key), term);
          return;
        }

        controller?.abort();
        controller = new AbortController();

        const shopRoot = window.Shopify?.routes?.root || '/';
        const url =
          shopRoot +
          'search/suggest.json?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=6';

        try {
          const response = await fetch(url, {
            signal: controller.signal,
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Predictive search failed: ' + response.status);

          const data = await response.json();
          const products = data?.resources?.results?.products || [];
          cache.set(key, products);

          if (input.value.trim() === term) render(products, term);
        } catch (error) {
          if (error?.name === 'AbortError') return;
          console.error('OMNI-CULT header live search failed', error);
          close();
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        const term = input.value.trim();
        if (!term) {
          close();
          return;
        }
        timer = window.setTimeout(() => requestResults(term), 180);
      });

      input.addEventListener('focus', () => {
        const term = input.value.trim();
        const cached = cache.get(term.toLocaleLowerCase());
        if (term && cached) render(cached, term);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          close();
          return;
        }

        const items = getItems();
        if (!root.classList.contains('is-open') || !items.length) return;

        if (event.key === 'ArrowDown') {
          event.preventDefault();
          selectItem(selectedIndex + 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          selectItem(selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1);
        } else if (event.key === 'Enter' && selectedIndex >= 0) {
          event.preventDefault();
          items[selectedIndex].click();
        }
      });

      results.addEventListener('mousemove', (event) => {
        const item = event.target.closest('[data-oc-header-live-option]');
        if (!item) return;
        const index = getItems().indexOf(item);
        if (index >= 0 && index !== selectedIndex) selectItem(index);
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) close();
      });

      form.addEventListener('submit', close);
    };

    const updateBadge = (target, count) => {
      if (!target) return;
      const itemCount = Math.max(0, Number(count) || 0);
      let bubble = target.querySelector('.cart-count-bubble');

      if (itemCount === 0) {
        bubble?.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        target.appendChild(bubble);
      }

      let visible = bubble.querySelector('span[aria-hidden="true"]');
      if (!visible) {
        visible = document.createElement('span');
        visible.setAttribute('aria-hidden', 'true');
        bubble.prepend(visible);
      }
      visible.textContent = itemCount < 100 ? String(itemCount) : '99+';

      let hidden = bubble.querySelector('.visually-hidden');
      if (!hidden) {
        hidden = document.createElement('span');
        hidden.className = 'visually-hidden';
        bubble.appendChild(hidden);
      }
      hidden.textContent = itemCount === 1 ? '1 item in cart' : itemCount + ' items in cart';
    };

    const updateCartBadges = (count) => {
      updateBadge(document.querySelector('.oc-desktop-cart'), count);
      updateBadge(document.querySelector('#cart-icon-bubble'), count);
    };

    const nativeCartCount = () => {
      const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (!bubble) return 0;
      const visible = bubble.querySelector('span[aria-hidden="true"]');
      const value = Number.parseInt(visible?.textContent || '0', 10);
      return Number.isFinite(value) ? value : 0;
    };

    const attachNativeCartObserver = () => {
      const nativeCart = document.querySelector('#cart-icon-bubble');
      if (!nativeCart || nativeCart.dataset.ocCartMirrorReady === 'true') return;
      nativeCart.dataset.ocCartMirrorReady = 'true';

      const mirror = () => {
        updateBadge(document.querySelector('.oc-desktop-cart'), nativeCartCount());
      };

      const observer = new MutationObserver(mirror);
      observer.observe(nativeCart, { childList: true, subtree: true, characterData: true });
      mirror();
    };

    let cartSyncTimer = 0;
    const syncCartBadges = () => {
      window.clearTimeout(cartSyncTimer);
      cartSyncTimer = window.setTimeout(async () => {
        try {
          const shopRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(shopRoot + 'cart.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) return;
          const cart = await response.json();
          updateCartBadges(cart.item_count);
        } catch (_) {}
      }, 60);
    };

    const attachCartListeners = () => {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          syncCartBadges();
          window.setTimeout(syncCartBadges, 250);
        });
      } else {
        window.setTimeout(attachCartListeners, 100);
      }
    };

    document.addEventListener(
      'submit',
      (event) => {
        const action = event.target?.getAttribute?.('action') || '';
        if (action.includes('/cart/add')) {
          window.setTimeout(syncCartBadges, 400);
          window.setTimeout(syncCartBadges, 900);
        }
      },
      true
    );

    document.addEventListener(
      'change',
      (event) => {
        if (event.target?.closest?.('cart-items, cart-drawer-items')) {
          window.setTimeout(syncCartBadges, 350);
          window.setTimeout(syncCartBadges, 850);
        }
      },
      true
    );

    const start = () => {
      initLiveSearch();
      attachCartListeners();
      attachNativeCartObserver();
      syncCartBadges();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
